import actionCreator from '../common/actionObjectCreator';
import uuidv1 from 'uuid/v1';
import submitData from '../common/postData';
import { getUserRegion } from 'helpers/userStorage';

export const actionDescriptor = "shoppingCart/";

const createAction = actionCreator(actionDescriptor);

const ADD_TO_CART = createAction("ADD_TO_CART");
const RESET = createAction("RESET");
const REMOVE_PORTFOLIO = createAction("REMOVE_PORTFOLIO");

const LOAD_CART = createAction("LOAD_CART");
const LOAD_CREDITS = createAction("LOAD_CREDITS");

export function addPortfolioToCart(portfolio) {
    return {
        type: ADD_TO_CART.default,
        payload: portfolio
    };
}
export function removePortfolio(portfolio) {
    return {
        type: REMOVE_PORTFOLIO.default,
        payload: portfolio
    };
}

export function loadCart(portfolios = []) {
    return dispatch => {
        submitData(`payment/getshoppingcartdata/${portfolios.length}/${getUserRegion()}`, {}, LOAD_CART, dispatch, true, {}, 'GET', true, 1000);
    }
}

export function getUserCredits() {


    return dispatch => {
        submitData(`payment/getusercredits/${getUserRegion()}`, {}, LOAD_CREDITS, dispatch, true, {}, 'GET', true, 1000);
    }
}

export function clear() {
    return {
        type: RESET.default
    };
}

var minVersion = .1;
var maxVersion = .9;

function getDefault() {

    let cart = getStorage();

    if (cart) {
        cart = JSON.parse(cart);

        if (cart && cart.version >= minVersion && cart.version <= maxVersion) {

        }
        else {
            cart = null;
        }

    }

    if (!cart) {
        cart = {
            version: 0.1,
            portfolios: [
            ]
        }
    }

    return {
        cart,
        loading: true,
        data: {

        }
    };
}

function getStorage() {
    return localStorage.getItem('cart');
}

function updateStorage(data) {
    localStorage.setItem('cart', JSON.stringify(data.cart));
}

const defaultState = getDefault();

const cleanPortfolio = (portfolio) => {
    var empty = portfolio.contributions.filter(e =>
        !e.cashWithdrawl &&
        !e.contribution &&
        !e.securitiesTransferred &&
        !e.securitiesWithdrawn && 
        !e.feePaidToManager
    );

    empty.forEach(cont => {
        var i = portfolio.contributions.indexOf(cont);
        portfolio.contributions.splice(i, 1);
    });

    empty = portfolio.fees.filter(e =>
        !e.feePaidToManager
    );

    empty.forEach(cont => {
        var i = portfolio.fees.indexOf(cont);
        portfolio.fees.splice(i, 1);
    });

};

const reducer = (state = defaultState, action) => {
    var ret, index, found;

    switch (action.type) {
        case ADD_TO_CART.default:
            ret = Object.assign({}, state);
            var p = { ...action.payload, id: action.payload.id ? action.payload.id : uuidv1() }

            found = ret.cart.portfolios.find(e => e.id === p.id);

            if (found) {
                index = ret.cart.portfolios.indexOf(found);
                ret.cart.portfolios.splice(index, 1);
            }

            cleanPortfolio(p);

            ret.cart.portfolios.push(JSON.parse(JSON.stringify(p)));
            updateStorage(ret);
            return ret;
        case REMOVE_PORTFOLIO.default:
            ret = Object.assign({}, state);

            found = ret.cart.portfolios.find(e => e.id === action.payload.id);

            if (found) {
                index = ret.cart.portfolios.indexOf(found);
                ret.cart.portfolios.splice(index, 1);
            }
            updateStorage(ret);
            return ret;
        case RESET.default:
            ret = Object.assign({}, state);
            ret.cart.portfolios = [];
            updateStorage(ret);
            return ret;
        case LOAD_CART.pending:
            ret = Object.assign({}, state, { loading: true, data: null });
            return ret;
        case LOAD_CART.fulfilled:
            ret = Object.assign({}, state, { loading: false, data: action.payload });
            return ret;
        case LOAD_CREDITS.pending:
            ret = Object.assign({}, state, { userCredits: -1 });
            return ret;
        case LOAD_CREDITS.fulfilled:
            ret = Object.assign({}, state, { userCredits: action.payload.credits });
            return ret;
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/shoppingCart/shoppingCart.duck.js